import weightLifting from "../assets/weight lifting.jpg";
import cardio from "../assets/cardio.jpg";
import boxing from "../assets/boxing.jpg";
import fatburning from "../assets/fatBurning.jpg";
import strength from "../assets/strength.jpg";

export const OfferData = [
  {
    image: weightLifting,
    header: "Strength",
    subheader: "Weightlifting",
  },
  {
    image: cardio,
    header: "cardio",
    subheader: "indoor cycling",
  },
  {
    image: fatburning,
    header: "Strength",
    subheader: "KettleBell Power",
  },
  {
    image: boxing,
    header: "Training",
    subheader: "Boxing",
  },
  {
    image: strength,
    header: "Health fitness",
    subheader: "exercies only",
  },
];
